export default {
    title: "এএলইউ",
    ssv: "নির্দিষ্ট দক্ষতা ভিসা",
    what_ssv: "নির্দিষ্ট দক্ষতা ভিসা",
    representative_message: "প্রতিনিধি বার্তা",
    aeru_feature: "AELU এর বৈশিষ্ট্যগুলি",
    aeru_how_to_use: "ব্যবহারের প্রবাহ",
    aeru_q_a: "প্রশ্নোত্তর",
    aeru_function: "AELU এর কাজ",
    aeru_fee: "AELU চার্জ",
    login: "প্রবেশ করুন",
    db_top_comment1: "ইন্ডাস্ট্রিতে প্রথম! নির্দিষ্ট দক্ষতা ভিসা পরীক্ষা এর জন্য স্মার্টফোন অনলাইন প্রশিক্ষণ সাইট।",
    db_top_comment2: "এএলইউ এমন একটি ওয়েব সার্ভিস যা পরীক্ষা, পরীক্ষার তথ্য এবং অ্যাপ্লিকেশন এজেন্সির জন্য অধ্যয়ন করে নির্দিষ্ট দক্ষতা ভিসা অর্জনকে সমর্থন করে।",
    db_top_pr: "নতুন সুযোগগুলি ব্যবহার করতে আপনার নির্দিষ্ট দক্ষতা ভিসা ব্যবহার করুন।",
    member_regist: "সদস্য নিবন্ধন",
    registration_support_organization: "একটি নিবন্ধন সমর্থন সংস্থা কি?",
    rso_dec1: "সুনির্দিষ্ট দক্ষতা ব্যবস্থায় দুটি সংস্থা রয়েছে, নির্দিষ্ট দক্ষতা অনুমোদিত সংস্থা এবং নিবন্ধকরণ সহায়তা সংস্থা। একটি নির্দিষ্ট দক্ষতা সম্পর্কিত সংস্থা হল একটি সংস্থা (গ্রহণযোগ্য সংস্থা) যা নির্দিষ্ট দক্ষতার সাথে বিদেশীদের নিয়োগ দেয়। যে প্রতিষ্ঠানের সাথে সুনির্দিষ্ট দক্ষতা রয়েছে সেগুলি অবশ্যই কর্মক্ষেত্র, দৈনন্দিন জীবন এবং সমাজে নির্দিষ্ট দক্ষতার সাথে বিদেশীদের সহায়তা সরবরাহ করতে পারে।",
    rso_dec2: "যেহেতু সুনির্দিষ্ট দক্ষতার সাথে বিদেশীদের সহায়তা করার ক্ষেত্রে বিশেষ বিষয়বস্তু রয়েছে, তাই এমন কিছু ক্ষেত্রে রয়েছে যে সংস্থার পক্ষে নির্দিষ্ট দক্ষতাযুক্ত বিদেশীদের নিয়োগ দেওয়া, যে প্রতিষ্ঠানের সাথে নির্দিষ্ট দক্ষতা রয়েছে তাদের সহায়তা সরবরাহ করা কঠিন। রেজিস্ট্রেশন সহায়তা সংস্থা হ ল এমন একটি সংস্থা যা নির্দিষ্ট দক্ষতা সম্পন্ন বিদেশীদের জন্য একটি সমর্থন পরিকল্পনা তৈরি এবং বাস্তবায়নের জন্য একটি নির্দিষ্ট দক্ষতা অনুমোদিত সংস্থাকে অর্পিত হয়।",
    rso_dec3: "রেজিস্ট্রেশন সহায়তা সংস্থা হল এমন একটি সংস্থা যা নির্দিষ্ট দক্ষতা সম্পন্ন বিদেশীদের জন্য একটি সমর্থন পরিকল্পনা তৈরি এবং বাস্তবায়নের জন্য একটি নির্দিষ্ট দক্ষতা অনুমোদিত সংস্থাকে অর্পিত হয়।",
    rso_dec4: "রেজিস্ট্রেশন সহায়তা সংস্থা হোস্ট সংস্থার সাথে একটি সমর্থন চালান চুক্তির মাধ্যমে নম্বর 1 নির্দিষ্ট স্কিলড এলিয়েন সাপোর্ট প্ল্যানের ভিত্তিতে সমস্ত সহায়তা সরবরাহ করবে।",
    rso_dec5: "A রেজিস্ট্রেশন সহায়তা সংস্থায় পরিণত হওয়ার জন্য, আপনাকে জাপানের ইমিগ্রেশন ব্যুরোর কমিশনার দ্বারা নিবন্ধিত করা দরকার।",
    rso_dec6: "○ নিবন্ধিত সংস্থাগুলি নিবন্ধন সহায়তা সংস্থার নিবন্ধনে নিবন্ধিত হবে এবং জাপানের ইমিগ্রেশন ব্যুরো ওয়েবসাইটে পোস্ট করা হবে।",
    rso_dec7: "Registration নিবন্ধকরণ সময়কাল 5 বছর এবং পুনর্নবীকরণ করা প্রয়োজন।",
    rso_dec8: "Registration নিবন্ধন সমর্থন সংস্থাগুলিকে যে কোনও সময় জাপানের ইমিগ্রেশন ব্যুরোতে বিভিন্ন বিজ্ঞপ্তি জমা দিতে হবে।",
    article1: "একটি নির্দিষ্ট দক্ষতা ভিসা কি?",
    article1_dec1: "8 ই ডিসেম্বর, 2018 এ সংশোধিত ইমিগ্রেশন কন্ট্রোল আইন কার্যকর করার সাথে সাথে, আবাসিক নির্দিষ্ট দক্ষতার অবস্থানটি নতুনভাবে প্রতিষ্ঠিত হয়েছিল। এপ্রিল 2019 এ প্রয়োগ করা হয়েছে।",
    article1_dec2: "আবাসিক নির্দিষ্ট দক্ষতার নতুন স্থিতি দুটি পর্যায়ে প্রতিষ্ঠিত হবে। (নং 1 এবং নং 2)",
    article1_dec3: "লক্ষ্যমাত্রা শিল্প 14 টি শিল্প।",
    article1_dec4: "লক্ষ্য বিদেশীদের প্রয়োজন এমন একজন ব্যক্তি যার দক্ষতা রয়েছে যার যথেষ্ট জ্ঞান বা অভিজ্ঞতা প্রয়োজন। অন্য কথায়, যারা তিন বছরের প্রযুক্তিগত ইন্টার্ন প্রশিক্ষণ সম্পন্ন করেছেন বা যারা সমান জাপানী ভাষা এবং দক্ষতা পরীক্ষায় উত্তীর্ণ হয়েছেন তারা যোগ্য।",
    article1_dec5: "নির্দিষ্ট দক্ষতা নং 1-কে নির্দিষ্ট দক্ষতাযুক্ত ব্যক্তি হিসাবে 5 বছর অবধি থাকার অনুমতি রয়েছে। পরিবারের সদস্যদের অনুমতি নেই।",
    article1_dec6: "দক্ষ দক্ষতা সম্পন্ন ব্যক্তি হিসাবে, সুনির্দিষ্ট দক্ষতা নং 2-কে নির্দিষ্ট দক্ষ নং 1 এর সময়কালে একটি বিশেষায়িত পরীক্ষায় পাস করে সাধারণ কর্মসংস্থানের সমতুল্য আবাসনের মর্যাদা দেওয়া হয়। \n (থাকার সময়কাল পুনর্নবীকরণের মাধ্যমে আপনি বাঁচতে পারবেন স্থায়ীভাবে, এবং আপনি আপনার পরিবারকে আপনার সাথে আনতে পারেন))",
    article2: "প্রতিনিধি বার্তা",
    article2_sub1: "জাপান ত্যাগ করুন না",
    article2_dec1: "আমরা প্রযুক্তিগত ইন্টার্ন প্রশিক্ষণার্থী হিসাবে জাপানে এসেছেন এমন অনেক প্রযুক্তিগত ইন্টার্ন প্রশিক্ষণার্থী এবং ফিরে আসা প্রশিক্ষণার্থীর প্রতি আন্তরিক কৃতজ্ঞতা প্রকাশ করতে চাই, তাদের দক্ষতা অর্জন করেছে এবং তাদের নিজের দেশের উন্নয়নে কোন প্রয়াস ছাড়েনি। আমি মনে করি যে পরিবারের পক্ষে এবং স্বদেশের জন্য অনুশীলনের উপস্থিতি, যা আজ জাপানে নেই, এটিই মানুষের আসল চেহারা। যদিও আমি দীর্ঘদিন ধরে প্রযুক্তিগত ইন্টার্ন প্রশিক্ষণের ব্যবসায়ের সাথে জড়িত ছিলাম, কেবলমাত্র কোনও প্রযুক্তিগত ইন্টার্ন প্রশিক্ষণার্থী ভিসা নিয়ে দেশে প্রবেশের কোনও উপায় নেই এবং আমি সেই সুযোগটি কাজে লাগিয়ে জাপানে দৃly়ভাবে অনুশীলন করব, আমার একটি ব্যবসা খুলব নিজস্ব দেশ, এবং আমার দেশ ব্যাপকভাবে বিকাশ করছে আমি অনেক কিছু দেখেছি। যাইহোক, এপ্রিল 2019 এ, একটি ভিসা স্পেশাল স্কিল ভিসা নির্মিত হয়েছিল, যা জাপান উপভোগ করার আকাঙ্ক্ষাকে পূরণ করে, যা নির্ধারিত বছরের মধ্যে পুরোপুরি শেখা যায় না। আমি আশা করি যে জাপান সফরকারী অনেক বিদেশীর চোখের পিছনে উচ্চাকাঙ্ক্ষা রয়েছে, যা জাপানে বিরল, তারা জাপান একসাথে বিকাশ করতে পারে। সর্বোপরি, আমি জাপানের মতো লোকদের থাকতে চাই, স্থায়ী বাসিন্দার সংখ্যা বৃদ্ধি করতে এবং এমন একটি সমাজ তৈরি করতে চাই যেখানে তারা একসাথে থাকতে পারে।",
    article2_dec2: "ভিজ্যুয়ালাইজেশন কোং, লিমিটেড",
    article2_dec3: "প্রেসিডেন্ট ও প্রধান নির্বাহী কর্মকর্তা",
    article2_dec4: "কাজুহিকো হরিওচি",
    article3: "AELU দ্বারা সরবরাহ করা তিনটি বৈশিষ্ট্য",
    article3_sub1: "অনলাইন পরীক্ষা জন্য পড়াশোনা",
    article3_sub1_dec1: "AELU, যা আপনাকে আপনার স্মার্টফোনে সুনির্দিষ্ট দক্ষতা পরীক্ষার জন্য প্রস্তুত করার অনুমতি দেয়, বিগত প্রশ্নাবলী সহ 14 টি শিল্পে 30 টি প্রশ্নের পরে সিউডো-প্রশ্নগুলি প্রস্তুত করে এবং আপনি পরীক্ষার তারিখের দিকে যতবার ইচ্ছা পদক্ষেপ নিতে পারবেন। আপনি যদি এআই দ্বারা পপআপ করা প্রশ্নগুলির জন্য নির্দিষ্ট স্কোর অতিক্রম করে থাকেন তবে আপনি অবশ্যই পরীক্ষায় উত্তীর্ণ হবেন!",
    article3_sub2: "পরীক্ষার তথ্য",
    article3_sub2_dec1: "জাপানের বিদেশী দর্শনার্থীদের পক্ষে এটি বোঝার জন্য পরীক্ষা করা তথ্যগুলি নিবন্ধকরণের পরে নির্বাচিত শিল্পের পরীক্ষার তথ্য আপডেট হওয়ার পরে স্বয়ংক্রিয়ভাবে যুক্ত হয়ে যাবে এবং ব্যবহারকারীকে অবহিত করা হবে।",
    article3_sub3: "পরীক্ষার আবেদন সংস্থা",
    article3_sub3_dec1: "পরীক্ষার তথ্যের মতো জাপানে বিদেশী দর্শনার্থীদের পক্ষে পরীক্ষার জন্য আবেদন করা খুব কঠিন এবং আপনি অনলাইন পদ্ধতি শেষ না করেও পরীক্ষা দিতে পারবেন না। আপনি যখন নিবন্ধন করবেন, আপনি তথ্য পোস্ট করতে পারেন, ইতিমধ্যে আবেদন ফর্মটি থাকতে পারে এবং পরীক্ষার ঘোষণার পাশাপাশি একই সময়ে আবেদন করতে পারেন।",
    article4: "পরীক্ষা পাস করার পরে ফাংশন ভূমিকা",
    article4_sub1: "সফল আবেদনকারীদের জন্য অভিনন্দন \n নগদ ফিরে (দেশীয় বা আন্তর্জাতিক)",
    article4_sub1_dec1: "আপনি যদি ইতিমধ্যে জাপানে থাকেন এবং AELU ব্যবহার করে পাস করেন এবং পাস নম্বরটি এবং পাসওয়ার্ডটি আপনার ব্যবহারকারীর স্ক্রিনে আপলোড করেন তবে আপনি একই দিনে নগদ ফেরত পেতে পারেন। নগদ ব্যাক প্ল্যান পণ্য: অনলাইন উপহারের শংসাপত্র (অ্যামাজন উপহারের শংসাপত্র ইমেল) প্রকার, গুগলপ্লে, আইটিউনস উপহার কার্ড) লাইন অফিসিয়াল অ্যাকাউন্ট থেকে 5000 ইয়েন মূল্য নগদ ফিরে।",
    article4_sub2: "রেফার-এ-ফ্রেন্ড ক্যাম্পেইন",
    article4_sub2_dec1: "জাপানে জাপানে বা বিদেশে যারা আবেদনকারীরা এফবি গ্রুপে যোগ দিতে জাপানে আমন্ত্রণ জানান, ব্যবহারকারী তার নিজের নম্বর এবং সেই সংখ্যার সাথে সম্পর্কিত ব্যক্তিকে নগদ ফেরত দেবেন এবং পরিচয়কারীর সাথে 1000 অনলাইন উপহারের শংসাপত্র দেওয়া হবে যোগদানের পরে মাস। ইয়েন নগদ ফেরত।",
    article4_sub3: "ভিসা পাওয়ার পরে, চাকরির সন্ধান করা হল AI n এআই স্বয়ংক্রিয় ম্যাচিং (সিদ্ধান্তহীন)",
    article4_sub3_dec1: "AELU ব্যবহার করে শংসাপত্র পরীক্ষায় উত্তীর্ণ হওয়ার পরে ব্যবহারকারীর স্ক্রিনে পাস নম্বর এবং পাস শংসাপত্র আপলোড করুন এবং আপনি জাপানের সমস্ত সংস্থার থেকে স্বয়ংক্রিয় অফার পাবেন offers সাক্ষাত্কারগুলিও অনলাইনে পরিচালিত হবে, এবং আপনি প্রাথমিক অনানুষ্ঠানিক অধ্যায়ে এমনকি অনলাইনে সংযোগ করে দেশে প্রবেশ করতে, স্থানান্তর করতে এবং মানসিক শান্তিতে একটি চাকরি পেতে সক্ষম হবেন!",
    article4_sub4: "বাসস্থান কার্ডের নিয়মিত চেক \n নগদ ব্যাক (অনির্ধারিত)",
    article4_sub4_dec1: "আপনি যদি আবাসিক কার্ড চেক অ্যাপ্লিকেশন ওয়ান চেক ট্যাবে আকাশ ছাড়াই মাসে একবার আপনার বাসস্থান কার্ড পরীক্ষা করেন, তবে আপনি এক বছরে 10,000 ইয়েন নগদ ফেরত পাবেন",
    article5: "নির্দিষ্ট ফাংশন ভূমিকা",
    article5_sub1: "আপনি যে সমস্যার সমাধান করেছেন তা ফিরে পেতে পারেন",
    article5_sub1_dec1: "আপনি অনলাইনে প্রশিক্ষিত যে পরীক্ষার বিষয়বস্তু সংগ্রহ করতে পারেন এবং ব্যবহারকারীর অভ্যাস বুঝতে এবং আপনার পক্ষে ভাল না এমন সমস্যাগুলি কাটিয়ে উঠতে নিজের সরঞ্জামগুলি ব্যবহার করতে পারেন। যেহেতু আপনি যতবার চান তার জন্য পরীক্ষার জন্য প্রস্তুত করতে পারেন, সমস্ত স্কোরের ইতিহাস এবং পরীক্ষার সময়টি রেকর্ড করুন এবং এটি যথাসময়ে পরীক্ষার দিনের নিকটবর্তী করে তুলুন। এছাড়াও, আপনি প্রশ্নটি আরও ভাল বুঝতে পারবেন কারণ এটি আপনার নিজস্ব ভাষা এবং জাপানি উভয় ভাষায় লেখা হয়েছে।",
    article5_sub2: "প্রবেশের সময় আপনার জীবনবৃত্তান্ত স্থায়ীভাবে সংরক্ষণ করুন",
    article5_sub2_dec1: "আপনি যখন সুনির্দিষ্ট দক্ষ ভিসা পরীক্ষা গ্রহণ করেন এবং ভিসার জন্য আবেদন করেন, আপনি যখন প্রযুক্তিগত ইন্টার্ন প্রশিক্ষণার্থী হিসাবে জাপানে প্রবেশ করবেন তখন আপনাকে পুনরায় শুরু করতে হবে। মূলত একটি পরিচালনা সংস্থা (সমবায়) বা প্রেরণ সংস্থা দ্বারা সঞ্চিত, আপনি একটি নির্দিষ্ট দক্ষতা ভিসা পাওয়ার পরে এটি নিজের দ্বারা সংরক্ষণ করতে পারেন।",
    article5_sub3: "আপনার দেশ এবং ক্ষেত্রের নিবন্ধকরণ কার্যক্রম",
    article5_sub3_dec1: "যেহেতু আপনার নিজের দেশ এবং জাপানের ভাষা একসাথে ব্যবহৃত হয়েছে, আপনি প্রশ্নগুলি ভালভাবে বুঝতে এবং পাল্টা ব্যবস্থা নিতে পারেন। মূল পরীক্ষায়, কেবল জাপানিই উপলব্ধ, তাই আপনি কেবল জাপানি ভাষায় ব্যবস্থা নিতে পারেন",
    article5_sub4: "শংসাপত্র পরীক্ষার প্রয়োজনীয়তা এবং তথ্যের অনুস্মারক",
    article5_sub4_dec1: "যখন প্রতিটি পরীক্ষার গ্রুপ দ্বারা কাঙ্ক্ষিত পেশার পরীক্ষার সময়সূচি এইচপিকে আপলোড করা হবে তখন তা স্বয়ংক্রিয়ভাবে মনে করিয়ে দেওয়া হবে, ব্যবহারকারীকে জানানো হবে, পরীক্ষার তারিখটি ব্যবহারকারীর স্ক্রিনে সেট করা হবে এবং টাইমারটি স্বয়ংক্রিয়ভাবে কাজ করবে।",
    article5_sub5: "স্ক্রিনিং ব্যবহার করে শিখছি",
    article5_sub5_dec1: "আপনি ব্যবহারকারীর দুর্বল পয়েন্টগুলি বের করতে এবং পরীক্ষার জন্য প্রস্তুত করতে পারেন।",
    article5_sub6: "স্মার্টফোন ক্যামেরা ব্যবহার করে অনলাইনে শেখার পরামর্শ এবং সাক্ষাত্কার।",
    article5_sub6_dec1: "আয়ার ব্যবহার করে পরীক্ষার প্রস্তুতি নিয়ে এগিয়ে যাওয়ার সময়, আপনি অনলাইন কল এবং চ্যাট আকারে প্রশ্নের অর্থ এবং উদ্দেশ্যটি পরিষ্কার করতে সক্ষম হবেন। যারা জাপানের সাথে অভ্যস্ত বা যারা এর সাথে পরিচিত তাদের জন্য এটি প্রয়োজনীয় নাও হতে পারে তবে পরীক্ষার আগে যে কোনও উদ্বেগ পরীক্ষা করার জন্য বেসিক কল কনসালটেশন সার্ভিসই সবচেয়ে আশ্বাসজনক উপায়!",
    article6: "ফি",
    article6_sub1: "AELU ব্যবহারের ফি",
    article6_sub1_dec1: "আপনি কোনও সীমাবদ্ধতা ছাড়াই নির্দিষ্ট দক্ষতা ভিসা পরীক্ষার জন্য অধ্যয়ন করতে পারেন। আপনি নিজের মাতৃভাষায় অনলাইনে পরামর্শ নিতে পারেন। * আপনি এটি সাধারণ সময়ে দোভাষী হিসাবেও ব্যবহার করতে পারেন। । n পরীক্ষার দিন পরীক্ষার সাইটে ঘোষণা করা সম্ভব। entry n প্রবেশের পরে পুনরায় শুরু করা চিরকালের জন্য সংরক্ষণ করা যায়। passing n পরীক্ষা পাস করার পরে, আপনার কাঙ্ক্ষিত কাজটি প্রবর্তনের জন্য কেবল আপনার নির্দিষ্ট দক্ষতা ভিসা পাস নম্বরটি নিবন্ধ করুন। (সিদ্ধান্তহীন)",
    article6_sub2: "পরীক্ষার আবেদন সংস্থা",
    article6_sub2_dec1: "কাজের সময় আপনি আবেদন করতে পারবেন না এবং আপনি আবেদন না করা ছাড়া শংসাপত্রের পরীক্ষা দিতে পারবেন না, সুতরাং শংসাপত্র পরীক্ষার তথ্য পাওয়া গেলে আমরা তাত্ক্ষণিকভাবে আবেদন করব যাতে আপনি পরীক্ষার তারিখ মিস না করেন।",
    article7: "ক্যাশব্যাক ক্যাম্পেইন চলছে!",
    article7_dec1: "যারা পরীক্ষায় উত্তীর্ণ হয়েছেন তাদের কাছ থেকে, যারা এই পরিষেবার জন্য ভিসা নম্বর নিবন্ধন করেছেন তারা 5000,000 y n ইয়েনের নগদ ফেরত পাবেন! কীভাবে প্রচারে অংশ নেওয়ার জন্য এখানে ক্লিক করুন।",
    article8: "এবার এইএলইউ দিয়ে রেজিস্ট্রেশন করি!",
    dashboard: "ড্যাশবোর্ড",
    member_info: "প্রোফাইল তথ্য নিবন্ধকরণ",
    first_name: "নাম",
    midle_name: "মাঝের নাম",
    family_name: "পদবি",
    half_width_Roman: "রোমাজি অর্ধ প্রস্থ",
    password: "পাসওয়ার্ড",
    password_confirm: "পাসওয়ার্ড নিশ্চিতকরণ",
    mail_adress: "ইমেইলর ঠিকানা",
    lineId: "লাইন আইডি",
    country_id: "কান্ট্রি কোড",
    phone: "ফোন নম্বর",
    issuing_country: "আইডি কার্ড জারি করার দেশ / অঞ্চল নির্বাচন করুন",
    IDtype: "আইডি টাইপ নির্বাচন",
    residence_card: "আবাস কার্ড বা আইডি কার্ড",
    passport: "পাসপোর্ট",
    regist: "নিবন্ধন",
    is_required: "আবশ্যক",
    sign_up: "নিবন্ধন করুন",
    residence_front: "সারফেস আপলোড",
    residence_back: "পিছনে আপলোড করুন",
    passport_upload: "আপনার পাসপোর্ট আপলোড করুন",
    error_file: "দয়া করে ছবিটি আপলোড করুন",
    post_resume: "পুনঃসূচনা জমা দিন",
    resume_upload: "আপলোড পুনরায় শুরু করুন",
    click_upload: "আপলোড করতে ক্লিক করুন",
    image_drop: "অথবা চিত্র ফাইলটি টানুন এবং ফেলে দিন",
    select_language: "মাতৃভাষার পছন্দ",
    vietnamese: "ভিয়েতনামী",
    chinese: "চাইনিজ",
    english: "ইংরেজি",
    khmer: "খেমার",
    indonesian: "ইন্দোনেশিয়ান",
    tagalog: "তাগালগ",
    burmese: "বার্মিজ",
    hindu: "হিন্দু",
    lao: "লাও",
    mongolian: "মঙ্গোলিয়ান",
    bengali: "বাংলা",
    sinhala: "সিংহলা",
    banglodesh: "বাংলাদেশী",
    malay: "মালয়",
    nepali: "নেপালি",
    thai: "থাই",
    japanese: "জাপানি",
    error_lang: "আপনার স্থানীয় ভাষা নির্বাচন করুন।",
    select_ouccupation: "কাজের ধরণের নির্বাচন",
    select_max_three: "আপনি তিনটি পর্যন্ত নির্বাচন করতে পারেন।",
    industry_id_1: "দীর্ঘমেয়াদী যত্ন শিল্প",
    industry_id_2: "ভবন পরিষ্কারের ব্যবসা",
    industry_id_3: "কাঁচামাল শিল্প",
    industry_id_4: "শিল্প যন্ত্রপাতি উত্পাদন শিল্প",
    industry_id_5: "বৈদ্যুতিক এবং বৈদ্যুতিন তথ্য সম্পর্কিত শিল্প",
    industry_id_6: "নির্মাণ শিল্প",
    industry_id_7: "শিপ বিল্ডিং / সামুদ্রিক শিল্প",
    industry_id_8: "গাড়ি রক্ষণাবেক্ষণ শিল্প",
    industry_id_9: "বিমান শিল্প",
    industry_id_10: "আবাসন ব্যবসা",
    industry_id_11: "কৃষি",
    industry_id_12: "ফিশারি",
    industry_id_13: "খাদ্য, পানীয় ও তামাক প্রস্তুত",
    industry_id_14: "রেস্তোঁরা ব্যবসা",
    industry: "শিল্প",
    error_occupation: "এক বা একাধিক কাজের ধরণ নির্বাচন করুন।",
    do: "করতে",
    news_tpic: "খবর",
    days_until_exam: "পরীক্ষার আগ পর্যন্ত বাকী দিন",
    estimated_pass_rate: "আনুমানিক পাসের হার",
    average_score_taken: "গৃহীত পরীক্ষার গড় স্কোর",
    exam: "পরীক্ষা হচ্ছে",
    let_aim: "জন্য লক্ষ্য দেয়",
    score: "পয়েন্ট",
    solve_problem: "প্রশ্ন সমাধান করুন",
    recommend_problem: "AELUs প্রস্তাবিত প্রশ্ন",
    solved_problem: "অতীতে সমস্যার সমাধান হয়েছে",
    looking_solved: "অতীত প্রশ্নগুলি পরীক্ষা করুন",
    consultaion_service: "পরামর্শ পরিষেবা শেখা",
    application_agency: "পরীক্ষার আবেদন সংস্থা পরিষেবা",
    billing: "বিলিং",
    more_look: "আরও পরীক্ষা করুন",
    more_look2: "আরও পরীক্ষা করুন",
    facebook: "ফেসবুক",
    google: "গুগল",
    until_not_account: "আপনার যদি এখনও একটি অ্যাকাউন্ট না থাকে",
    or: "বা",
    other_way: "অন্য উপায়ে",
    not_have_account: "আপনার যদি অ্যাকাউন্ট না থাকে",
    have_account: "আপনার যদি একাউন্ট থাকে",
    forgot_password: "আপনি যদি নিজের পাসওয়ার্ড ভুলে গেছেন",
    this: "এখানে",
    at_login: "সাথে লগইন করুন",
    pass_condition: "8 বা ততোধিক একক বাইট বর্ণমালার মূল অক্ষর",
    at_sign_up: "সঙ্গে নতুন নিবন্ধকরণ",
    agreement1: "নিম্নলিখিতগুলির সাথে একমত হয়ে এবং চালিয়ে যাওয়া চয়ন করে, AELU",
    terms: "সেবা পাবার শর্ত",
    agreement2: "আমি আপনার সাথে একমত.",
    agree: "একমত এবং অবিরত",
    account_confirm: "নিশ্চিতকরণের কোড",
    confirm: "নিশ্চিতকরণ",
    not_confirm: "নিশ্চিতকরণ কোডটি নিশ্চিত নয়।",
    move_confiirm: "নিশ্চিতকরণ কোড ইনপুট স্ক্রিনে সরানো",
    top: "শীর্ষ",
    news_list: "সংবাদ তালিকা",
    problim_list: "প্রশ্ন তালিকা",
    learning_consul: "পরামর্শ শেখা",
    agency: "পরীক্ষার তথ্য",
    of_trend: "পরীক্ষার ট্রেন্ড সম্পর্কে",
    start_test: "পরীক্ষা শুরু করুন",
    study_mode: "শেখার মোড",
    order_question: "প্রশ্ন",
    of_question: "প্রশ্নে",
    question_current: "প্রশ্ন সঠিক উত্তর",
    to_mypage: "আমার পৃষ্ঠায়",
    correct_answer: "সঠিক উত্তর!",
    correct_answer_normal: "সঠিক উত্তর",
    no_correct_answer: "ভুল উত্তর",
    next: "পরবর্তী প্রশ্নে",
    finish_all: "সব প্রশ্নের উত্তর!",
    your_score: "তোমার সংগ্রহ",
    is: "হয়!",
    result_description: "প্রশ্নগুলি দেখুন তালিকা থেকে আপনি অন্যান্য প্রশ্নের সমাধান করতে পারেন। আপনি অতীতের যে প্রশ্নগুলি সমাধান করেছেন সেগুলি প্রশ্নগুলির তালিকা পৃষ্ঠা থেকে ফিরে দেখতে পারেন।",
    back_quiz_list: "প্রশ্নের তালিকা পরীক্ষা করুন",
    retry: "এই প্রশ্নগুলি আবার সমাধান করুন",
    no_description: "এর কোন ব্যাখ্যা নেই",
    show_ans: "উত্তরটি পরীক্ষা করুন",
    of_solved_problem: "অতীতে সমস্যার সমাধান হয়েছে",
    of_solved_problem_list: "অতীতে সমাধান হওয়া প্রশ্নের তালিকা",
    solved_description: "দীর্ঘমেয়াদী যত্ন শিল্পের নির্দিষ্ট দক্ষতা ভিসা পরীক্ষার জন্য আপনি আবার শেখার পরীক্ষাটি পরীক্ষা করতে পারেন।",
    before_result: "পূর্ববর্তী ফলাফল",
    looking_back: "আবার পরীক্ষা করুন",
    back_solved_problem_list: "অতীতে সমাধান হওয়া প্রশ্নের তালিকা পরীক্ষা করে দেখুন",
    again_retry: "আবার এই প্রশ্নের পিছনে তাকানো",
    done_member_regist: "সদস্য হিসাবে নিবন্ধনের জন্য আপনাকে ধন্যবাদ!",
    done_member_regist_description: "আপনি পরিষেবা ব্যবহারের ফি প্রদানের পরে প্রতিটি পরিষেবা উপলব্ধ থাকবে। । n দয়া করে আপনার প্রদানের তথ্য নিবন্ধ করুন।",
    choose_payment: "অর্থ প্রদানের পদ্ধতিটি চয়ন করুন",
    service_content: "পরিষেবা সামগ্রী",
    test_info_service: "পরীক্ষার তথ্য পরিষেবা",
    usage_fee: "ব্যবহারের ফি",
    test_fee: "500 ইয়েন + ট্যাক্স",
    application_fee: "20000 ইয়েন + ট্যাক্স",
    method_payment: "মূল্যপরিশোধ পদ্ধতি",
    LINE_pay: "লাইন পে",
    line_pay_description: "* দয়া করে কিউআর কোড চিত্রটি সংরক্ষণ করুন এবং লাইন পে পরিষেবার মধ্যে অর্থ প্রদান করুন। লাইন পে দিয়ে অর্থ প্রদানের সময় ম্যানেজমেন্টকে এটি নিশ্চিত হতে সময় লাগবে।",
    save_qr: "কিউআর কোড সংরক্ষণ করুন",
    next_stage: "পরবর্তী",
    credit_card: "ক্রেডিট কার্ড",
    copmplete_payment: "অর্থ প্রদান সম্পূর্ণ।",
    copmplete_payment_descript: "এখন অর্থ প্রদান সম্পন্ন হয়েছে, আপনি অনলাইন পরীক্ষা অধ্যয়ন ফাংশন, পরীক্ষার তথ্য এবং পরীক্ষার আবেদন এজেন্সি পরিষেবা ব্যবহার করতে পারেন।",
    start_sevice: "পরিষেবাটি ব্যবহার শুরু করুন",
    to_payment: "পেমেন্ট স্ক্রিনে",
    of_news_list: "সংবাদ তালিকা",
    done_payment: "প্রদান সম্পন্ন হয়েছে।",
    tv_consult: "ভিডিওফোন পরামর্শ",
    tell_consult: "টেলিফোন পরামর্শ",
    learning_consul_descript01: "পরীক্ষার আবেদন",
    learning_consul_descript02: "আমরা আপনার পক্ষে কাজ করব",
    money_unit: "জেপিওয়াই",
    learning_consul_unit: "একদা",
    fault_payment1: "পেমেন্ট ব্যর্থ হয়েছে.",
    fault_payment2: "অনুগ্রহপূর্বক আবার চেষ্টা করুন.",
    no_examination: "এখনো পর্যন্ত না",
    no_exam: "এখনও পরীক্ষা নেই",
    undecided: "সিদ্ধান্তহীন",
    retry_login: "অনুগ্রহ পূর্বক আরো একবার প্রবেশ করুন",
    no_problem: "কোন সমাধান সমাধান করা হয় না",
    do_problem: "প্রশ্ন সমাধান করুন",
    qa_title: "সচরাচর জিজ্ঞাস্য",
    search_category: "বিভাগ অনুসারে সঙ্কুচিত",
    search_freeward: "নিখরচায় শব্দ দ্বারা অনুসন্ধান করুন",
    test_result: "অনুশীলন পরীক্ষার ফলাফল",
    to_top: "শীর্ষে",
    missPassword: "ভুল পাসওয়ার্ড বা ইমেল ঠিকানা",
    sample_problem: "একটি অনলাইন পরীক্ষার জন্য অধ্যয়নের অভিজ্ঞতা",
    exercises: "অনুশীলন",
    let_exercises: "আসুন শুধুমাত্র একটি বাস্তব সমস্যা সমাধান করা যাক!",
    to_qa: "আরও প্রশ্নোত্তর পরীক্ষা করুন",
    read_more: "আরও পরীক্ষা করুন",
    account_setting: "অ্যাকাউন্ট সেটিং",
    profile_setting: "প্রোফাইল সেটিংস",
    notification_setting: "বিজ্ঞপ্তি সেটিংস",
    logout: "প্রস্থান",
    changeEmail: "ই - মেইল ঠিকানা পরিবর্তন করুন",
    changePassword: "পাসওয়ার্ড পরিবর্তন করুন",
    change: "পরিবর্তন",
    save: "সংরক্ষণ",
    change_success: "পরিবর্তন সম্পন্ন হয়েছে",
    now_password: "বর্তমান পাসওয়ার্ড",
    new_password: "নতুন পাসওয়ার্ড",
    check_new_password: "নতুন পাসওয়ার্ড নিশ্চিতকরণ)",
    do_logout: "প্রস্থান",
    done_learning_consul_payment: "ইতিমধ্যে অর্থ প্রদান সম্পন্ন হয়েছে।",
    past_exam: "বিগত প্রশ্ন",
    update_info: "সর্বশেষ তথ্য আপডেট করা হচ্ছে",
    official_sns: "অফিসিয়াল এসএনএস",
    privacy_policy: "গোপনীয়তা নীতি",
    terms_service: "সেবা পাবার শর্ত",
    transaction_law: "নির্দিষ্ট বাণিজ্যিক লেনদেন আইনের উপর ভিত্তি করে স্বরলিপি",
    selectCountry: "একটি দেশ নির্বাচন করুন",
    goInquiry: "তদন্তে এগিয়ে যান",
    lineInquiry: "লাইন মাধ্যমে আমাদের সাথে যোগাযোগ করুন",
    regist_accept_certificate: "নির্দিষ্ট দক্ষতা ভিসা অধিগ্রহণ পাস শংসাপত্র নিবন্ধন",
    accept_certificate_description: "আপনি আপনার পাসের শংসাপত্র এবং নম্বর নিবন্ধন করতে পারেন",
    accept_certificate: "গ্রহণযোগ্যতার শংসাপত্র",
    accept_number: "পাস নম্বর",
    immigration_resume: "প্রবেশের সময় নিবন্ধন পুনরায় শুরু করুন",
    resendCode: "নিশ্চিতকরণ কোড আবার পাঠান",
    line_at_register: "লাইন @ এর মাধ্যমে পরিষেবা অনুসন্ধানগুলি",
    study: "অধ্যয়ন এবং আবার পরীক্ষা করুন",
    study_text: "শেখার পাঠ্য ডাউনলোড করুন",
    do_resume_update: "আপনার জীবনবৃত্তান্ত আপলোড করুন",
    done_resume_update: "আপনার জীবনবৃত্তান্ত নিবন্ধনের জন্য আপনাকে ধন্যবাদ!",
    regist_resume_enter: "প্রবেশের সময় পুনরায় শুরু করুন",
    about_company: "অপারেটিং সংস্থা সম্পর্কে",
    add_exam_info_detail: "পরীক্ষার তথ্য যুক্ত করা হয়েছে। বিশদ এবং আবেদনের জন্য এখানে ক্লিক করুন",
    regist_result_get_money: "আপনার পরীক্ষার ফলাফল নিবন্ধন করুন এবং আপনার অর্থ পান",
    detail: "বিশদ",
    about_withdrawal_subsc: "সাবস্ক্রিপশন প্রত্যাহার এবং বাতিলকরণ সম্পর্কে",
    apply_withdrawal: "সাবস্ক্রিপশনের জন্য আবেদন",
    apply_subsc: "সাবস্ক্রিপশন থেকে সাবস্ক্রাইব করার জন্য আবেদন",
    about_withdrawal: "প্রত্যাহারের আবেদন",
    about_subsc: "সাবস্ক্রিপশন থেকে সাবস্ক্রাইব করুন",
    exam_info: "পরীক্ষার তথ্য",
    date: "তারিখ এবং সময়",
    day: "দিন",
    place: "স্থান",
    result_publication: "ফলাফল প্রকাশনা",
    result_publication_place: "ফলাফল ঘোষণা করার জায়গা",
    result_this_page: "এই পৃষ্ঠায় ঘোষণা করা হবে",
    exam_way: "পরীক্ষার ফরম্যাট",
    exam_way2: "পরীক্ষার প্রশ্ন বিন্যাস",
    include_exam_fee: "পরীক্ষার ফি সহ",
    exam_application_desc: "পরীক্ষার আবেদন ফরম জমা দেওয়া। office n পরীক্ষা অফিসের সাথে কথোপকথন \n দিনের মধ্যে কী প্রস্তুতি নেওয়া হবে তার সাথে যোগাযোগ করা (লাইন @) \n পরীক্ষা সংক্রান্ত যে কোনও প্রশ্নের জন্য পরামর্শ",
    self_application: "নিজেই আবেদন করুন",
    application_method: "কিভাবে আবেদন করতে হবে",
    under_this_url: "নিম্নলিখিত URL থেকে আবেদন পদ্ধতিটি সম্পূর্ণ করুন।",
    do_appliction: "পরীক্ষার জন্য আবেদন করুন",
    study_with_aeru: "পাসের হার বাড়ানোর জন্য শীর্ষ পৃষ্ঠা থেকে পরীক্ষার অধ্যয়নের ফাংশনটি ব্যবহার করুন।",
    line_at_consul: "লাইন @ শেখার পরামর্শ পরিষেবা",
    instagram: "ইনস্টাগ্রাম",
    do_signup: "আপনি প্রমাণীকরণ করা হয়েছে। । n দয়া করে আবার লগ ইন করুন।",
    gender: "লিঙ্গ",
    man: "পুরুষ",
    woman: "মহিলা",
    input_problem_title: "সমস্যার শিরোনাম রয়েছে ...",
    still_no_problem: "সমস্যা নেই",
    enter_in_problem_trend: "পরীক্ষার সংক্ষিপ্ত বিবরণ রয়েছে যেমন পরীক্ষার ট্রেন্ডগুলি এখন পর্যন্ত এবং উত্তরের ফর্ম্যাট (নির্বাচনের ধরণ)।",
    correct: "সঠিক উত্তর",
    explanation: "ব্যাখ্যা",
    problem: "প্রশ্ন",
    do_nursing_not_published: "দীর্ঘমেয়াদী যত্ন শিল্পে পরীক্ষা নেওয়া হচ্ছে তবে অতীতের প্রশ্নগুলি প্রকাশিত হয়নি।",
    practical_exam_of_year: "বছরের ব্যবহারিক পরীক্ষা",
    judgment_test_of_year: "2019 জাজমেন্ট পরীক্ষা",
    judgment_test_answer_of_year: "2019 জাজমেন্ট পরীক্ষার উত্তর",
    not_yet_test_material: "কাঁচামাল শিল্পে এখনও পরীক্ষা হয়নি",
    not_yet_test_machinery: "শিল্প যন্ত্রপাতি উত্পাদন খাতে এখনও পরীক্ষা হয়নি",
    not_yet_test_electronic: "বৈদ্যুতিক এবং বৈদ্যুতিন তথ্য সম্পর্কিত শিল্পে এখনও পরীক্ষা হয়নি",
    not_yet_test_construction: "নির্মাণ শিল্পে এখনও পরীক্ষা হয়নি",
    not_yet_test_shipbuilding: "শিপ বিল্ডিং এবং সামুদ্রিক শিল্পে এখনও পরীক্ষা হয়নি",
    do_automobile_not_published: "অটোমোবাইল রক্ষণাবেক্ষণের ক্ষেত্রে পরীক্ষা নেওয়া হচ্ছে তবে অতীতের প্রশ্নগুলি প্রকাশিত হয়নি।",
    do_aviation_not_published: "বিমান শিল্পে পরীক্ষা নেওয়া হচ্ছে তবে অতীতের প্রশ্নগুলি প্রকাশিত হয়নি।",
    do_agricultural_not_published: "কৃষি খাতে পরীক্ষা নেওয়া হচ্ছে তবে অতীতের প্রশ্ন প্রকাশ করা হয়নি।",
    do_fishery_not_published: "ফিশারি ফিল্ডে পরীক্ষা নেওয়া হচ্ছে তবে অতীতের প্রশ্নগুলি প্রকাশ করা হয়নি।",
    do_food_not_published: "খাদ্য ও পানীয় উত্পাদন শিল্পে পরীক্ষা নেওয়া হচ্ছে তবে অতীতের প্রশ্নগুলি প্রকাশিত হয়নি।",
    do_restaurant_not_published: "খাদ্য পরিষেবা শিল্পে পরীক্ষা নেওয়া হচ্ছে তবে অতীতের প্রশ্নগুলি প্রকাশিত হয়নি।",
    schedule_undecided: "(* সময়সূচী অনিশ্চিত)",
    year: "বছর",
    month: "চাঁদ",
    texts_learning: "প্রতিটি শিল্প শেখার পাঠ্যপুস্তক",
    texts_learning_test: "নির্দিষ্ট দক্ষতা মূল্যায়ন পরীক্ষা শেখার পাঠ্য (জাপানি)",
    skill_test_sample: "দক্ষতা মূল্যায়নের পরীক্ষার নমুনা",
    japanese_test_sample: "জাপানি মূল্যায়ন পরীক্ষার নমুনা",
    not_building_texts: "ভবন পরিষ্কারের শিল্পের জন্য এখনও কোনও পাঠ্যপুস্তক নেই।",
    not_material_texts: "কাঁচামাল শিল্পের জন্য এখনও কোনও পাঠ্যপুস্তক নেই।",
    not_machinery_texts: "শিল্প যন্ত্রপাতি উত্পাদন ক্ষেত্রে এখনও শেখার পাঠ্যপুস্তক নেই।",
    not_electronic_texts: "বৈদ্যুতিন এবং বৈদ্যুতিন তথ্য সম্পর্কিত শিল্পগুলির জন্য কোনও পাঠ্যপুস্তক নেই।",
    not_shipbuilding_texts: "শিপ বিল্ডিং / সামুদ্রিক শিল্পের জন্য এখনও কোনও পাঠ্যপুস্তক নেই।",
    not_automobile_texts: "অটোমোবাইল রক্ষণাবেক্ষণ শিল্পের জন্য এখনও কোনও পাঠ্যপুস্তক নেই।",
    not_accommodation_texts: "আবাসন শিল্পের জন্য এখনও কোনও পাঠ্যপুস্তক নেই।",
    not_food_texts: "খাদ্য ও পানীয় উত্পাদন শিল্পের জন্য এখনও কোনও পাঠ্যপুস্তক নেই।",
    not_restaurant_texts: "খাদ্য পরিষেবা দক্ষতা পরিমাপ পরীক্ষা শেখার পাঠ্যপুস্তক",
    each_depertment_texts: "প্রতিটি বিভাগে পরীক্ষা শেখার পাঠ্যপুস্তক",
    skill_test_basic: "দক্ষতা মূল্যায়ন পরীক্ষা শেখার পাঠ্য (বেসিক প্রযুক্তি)",
    skill_test_safety: "দক্ষতা মূল্যায়ন পরীক্ষা শেখার পাঠ্য (কাজের সুরক্ষা / গুণমান)",
    skill_test_aircraft: "দক্ষতা মূল্যায়ন পরীক্ষা শেখার পাঠ্য (বিমানের ওভারভিউ)",
    texts_livestock: "[লাইভস্টক ফার্ম শেখার পাঠ্যপুস্তিকা] জাপানি সংস্করণ",
    texts_cultivated: "[কৃষিক্ষেত্রে কৃষি শেখার জন্য পাঠ্য] জাপানি সংস্করণ",
    skill_test_fishery: "মৎস্য দক্ষতা পরিমাপ পরীক্ষা (ফিশারি)",
    skill_test_general_fishery: "মৎস্য দক্ষতা পরিমাপ পরীক্ষা (সাধারণ ফিশারি)",
    skill_test_safety_fishery: "মৎস্য দক্ষতা পরিমাপ পরীক্ষা (ফিশারি সুরক্ষা)",
    skill_test_specialty_fishery: "ফিশারি দক্ষতা পরিমাপ পরীক্ষা (ফিশারি স্পেশালাইন্ড নেট সম্পর্কিত)",
    skill_test_related_fishery: "ফিশারি দক্ষতা পরিমাপ পরীক্ষা (ফিশারি স্পেশালিটি ফিশিং সম্পর্কিত)",
    skill_test_aquaculture: "মৎস্য দক্ষতা পরিমাপ পরীক্ষা (জলজ পালন)",
    skill_test_general_aquaculture: "ফিশারি দক্ষতা পরিমাপ পরীক্ষা (অ্যাকুয়ালচার জেনারেল / সুরক্ষা)",
    skill_test_feeding_aquaculture: "মৎস্য দক্ষতা পরিমাপ পরীক্ষা (খাওয়ানো এবং জলজ পালন)",
    skill_test_non_feeding_aquaculture: "মৎস্য দক্ষতা পরিমাপ পরীক্ষা (ফলিত জলজ সম্পর্কিত সম্পর্কিত)",
    registration_skill_visa: "নির্দিষ্ট দক্ষ ভিসার গ্রহণের শংসাপত্রের নিবন্ধকরণ",
    please_register_pdf_number: "একটি নির্দিষ্ট দক্ষতা ভিসা পাওয়ার জন্য দয়া করে পাস শংসাপত্রের ছবি বা পিডিএফ এবং পাস শংসাপত্রের পাস নম্বরটি নিবন্ধ করুন।",
    regist_and_get_cash_bag: "আপনি যদি এখন নিবন্ধন করেন, আপনি নগদ ব্যাগ সহ 5000 ইয়েন পেতে পারেন।",
    thank_you_regist_visa_pass: "নির্দিষ্ট দক্ষতা ভিসা পাসের শংসাপত্র নিবন্ধনের জন্য আপনাকে ধন্যবাদ!",
    exam_info_detail: "পরীক্ষার বাস্তবায়নের রূপরেখা",
    em_exam_detail_language: "স্থানীয় ভাষায় করা হবে নির্ধারিত",
    em_exam_detail_method: "বিভাগ পরীক্ষা, ব্যবহারিক পরীক্ষা",
    em_exam_detail_way: "কম্পিউটার ভিত্তিক পরীক্ষার (সিবিটি) কাগজ পরীক্ষার পদ্ধতি বা কাজের পরীক্ষার পদ্ধতি যেমন উত্পাদন",
    em_exam_detail_section: "19 পরীক্ষার বিভাগগুলি (ingালাই, ফোরজিং, ডাই কাস্টিং, মেশিনিং, মেটাল স্ট্যাম্পিং, আয়রনকর্ম, কারখানা শীট ধাতু, ধাতুপট্টাবৃত, অ্যালুমিনিয়াম অ্যানোডাইজেশন, সমাপ্তি, যান্ত্রিক পরিদর্শন, মেশিন রক্ষণাবেক্ষণ, বৈদ্যুতিন সরঞ্জাম সমাবেশ, বৈদ্যুতিক সরঞ্জাম সমাবেশ, মুদ্রিত তারের বোর্ড উত্পাদন, প্লাস্টিকের ingালাই) , পেইন্টিং, ldালাই, শিল্প প্যাকেজিং)",
    em_exam_detail_notify: "পরীক্ষার পরে ইমেলের মাধ্যমে ফলাফল বিজ্ঞপ্তি প্রেরণ করুন।",
    em_exam_detail_border: "বিভাগ পরীক্ষা: 65% বা তারও বেশি \n ব্যবহারিক পরীক্ষা: 60 পয়েন্ট বা তারও বেশি",
    ss_exam_detail_language: "জাপানি",
    ss_exam_detail_method: "দক্ষতা পরীক্ষাটি ব্যবহারিক পরীক্ষা এবং বিভাগীয় পরীক্ষা দ্বারা পরিচালিত হয়। business n প্রতিটি ব্যবসায়িক বিভাগের জন্য ব্যবহারিক পরীক্ষা নেওয়া হয়। । n কাগজ পরীক্ষা পদ্ধতি দ্বারা প্রতিটি ব্যবসায় বিভাগের জন্য বিভাগ পরীক্ষা করা হয়।",
    ss_exam_detail_way: "কাগজ পরীক্ষার পদ্ধতি ইত্যাদি",
    ss_exam_detail_section: "বিভাগ / অনুশীলন / দক্ষতা: eldালাই, পেইন্টিং, লোহা কাজ, সমাপ্তি, যন্ত্র, বৈদ্যুতিক সরঞ্জাম সমাবেশ",
    ss_exam_detail_notify: "-",
    ss_exam_detail_border: "বিভাগ পরীক্ষা: 60% বা তারও বেশি \n প্রাকটিক্যাল পরীক্ষা: ব্যবহারিক ফলাফলের ভিত্তিতে রায় দেওয়া",
    c_exam_detail_language: "জাপানি",
    c_exam_detail_method: "দক্ষতা পরীক্ষাটি ব্যবহারিক পরীক্ষা এবং বিভাগীয় পরীক্ষা দ্বারা পরিচালিত হয়।",
    c_exam_detail_way: "কম্পিউটার ভিত্তিক পরীক্ষা (সিবিটি), ব্যবহারিক পরীক্ষা নিবন্ধিত কর্পোরেশন দ্বারা নির্দিষ্ট একটি পদ্ধতি",
    c_exam_detail_section: "-",
    c_exam_detail_notify: "ওয়েবসাইটে প্রকাশিত",
    c_exam_detail_border: "বিভাগ পরীক্ষা: 65% বা তারও বেশি \n প্রাকটিক্যাল পরীক্ষা: ব্যবহারিক ফলাফলের ভিত্তিতে রায় দেওয়া",
    cm_exam_detail_language: "জাপানি",
    cm_exam_detail_method: "দক্ষতা পরীক্ষাটি ব্যবহারিক পরীক্ষা এবং বিভাগীয় পরীক্ষা দ্বারা পরিচালিত হয়।",
    cm_exam_detail_way: "কম্পিউটার ভিত্তিক পরীক্ষার (সিবিটি) মাধ্যমে একাডেমিক এবং ব্যবহারিক পরীক্ষা করা",
    cm_exam_detail_section: "বিষয় পরীক্ষার বিষয় \n কাঠামো, ফাংশন এবং পরিচালনা পদ্ধতি সম্পর্কে প্রাথমিক জ্ঞান inspection n পরিদর্শন, মেরামত ও সমন্বয় সম্পর্কে প্রাথমিক জ্ঞান \n কাঠামো, ফাংশন এবং পরীক্ষার মেশিনের পরিচালনা পদ্ধতি, পরিমাপের উপকরণ এবং রক্ষণাবেক্ষণের সরঞ্জাম সম্পর্কে প্রাথমিক জ্ঞান \n প্রাথমিক জ্ঞান উপকরণ এবং জ্বালানী এবং চর্বিগুলির বৈশিষ্ট্য এবং ব্যবহার সম্পর্কে \n প্রাকটিক্যাল পরীক্ষার বিষয়গুলি \n সহজ সরল মৌলিক কাজ \nB বিশৃঙ্খলা, সমাবেশ, সাধারণ পরিদর্শন এবং সমন্বয় C nC সহজ মেরামতের \nD রক্ষণাবেক্ষণ পরীক্ষার মেশিনগুলির সহজ পরিচালনা, যন্ত্র এবং সরঞ্জাম পরিমাপ।",
    cm_exam_detail_notify: "",
    cm_exam_detail_border: "বিভাগ পরীক্ষা: 65% বা তার বেশি ব্যবহারিক পরীক্ষার: মোট স্কোর 60% বা তারও বেশি",
    a_exam_detail_language: "স্থানীয় ভাষা এবং জাপানি",
    a_exam_detail_way: "কম্পিউটার ভিত্তিক পরীক্ষা (সিবিটি), কাগজ পরীক্ষার পদ্ধতি",
    a_exam_detail_section: "বিভাগ সাধারণভাবে কৃষিক্ষেত্র, সুরক্ষা এবং স্বাস্থ্য, আবাদকৃত ফসলের জাত / বৈশিষ্ট্য, চাষের পরিবেশ (সুবিধা / সরঞ্জাম / উপকরণ / যন্ত্রপাতি), আবাদ পদ্ধতি / পরিচালনা, পোকার / আগাছা নিয়ন্ত্রণ, ফসল সংগ্রহ / সমন্বয় / সঞ্চয় / শিপিং-প্রাকৃতিক মাটির পর্যবেক্ষণ, সার / কীটনাশক হ্যান্ডলিং, বীজ হ্যান্ডলিং, পরিবেশ ব্যবস্থাপনা, উপকরণ / সরঞ্জাম / মেশিন হ্যান্ডলিং, চাষাবাদ, সুরক্ষা এবং স্বাস্থ্য সম্পর্কিত কাজ Japanese জাপানি ভাষায় নির্দেশিত কৃষি কাজের বিষয়বস্তু শুনছেন",
    a_exam_detail_notify: "ওয়েবসাইটে প্রকাশিত",
    a_exam_detail_border: "মোট স্কোর কৃষিক্ষেত্রের জাতীয় চেম্বার দ্বারা নির্ধারিত রায় রেফারেন্স পয়েন্টটি ছাড়িয়ে গেছে ex",
    avi_exam_detail_method: "দক্ষতা পরীক্ষাটি ব্যবহারিক পরীক্ষা এবং বিভাগীয় পরীক্ষা দ্বারা পরিচালিত হয়।",
    avi_exam_detail_section: "জাপান এভিয়েশন টেকনোলজি অ্যাসোসিয়েশনের ওয়েবসাইটে পোস্ট করা পাঠ্যগুলি থেকে প্রশ্নগুলি দেওয়া হবে। ব্যবহারিক দক্ষতা উপসংহার, বৈদ্যুতিক পরিমাপ",
    avi_exam_detail_notify: "",
    avi_exam_detail_border: "বিভাগ পরীক্ষা: 65% বা আরও প্রাকটিক্যাল পরীক্ষা: মোট স্কোর 65% বা আরও বেশি",
    f_exam_detail_language: "জাপানি",
    f_exam_detail_method: "দক্ষতা পরীক্ষাটি ব্যবহারিক পরীক্ষা এবং বিভাগীয় পরীক্ষা দ্বারা পরিচালিত হয়।",
    f_exam_detail_way: "কম্পিউটার ভিত্তিক পরীক্ষার (সিবিটি) মাধ্যমে একাডেমিক এবং ব্যবহারিক পরীক্ষা করা",
    f_exam_detail_section: "পরীক্ষার বিষয়টি নিশ্চিত করবে যে মৎস্য ক্ষেত্রের (ফিশারি) বা ফিশারি ফিল্ডে (জলজ পালন) একটি নির্দিষ্ট ডিগ্রির কাজ সুপারভাইজারের নির্দেশাবলী বোঝার দ্বারা নির্ভুলভাবে সম্পাদন করা যেতে পারে বা তার নিজস্ব বিবেচনার ভিত্তিতে সম্পন্ন করা যেতে পারে, এবং এটি কেবল বিশেষায়িত । এটি জ্ঞানের উপস্থিতি বা অনুপস্থিতির মূল্যায়ন নয়, তবে ফিশারি ফিল্ড (ফিশারি) বা ফিশারি ফিল্ডে (জলজ পালন) কাজ পরিচালনার জন্য প্রয়োজনীয় সঠিক রায় এবং কাজের জ্ঞানের উপস্থিতি বা অনুপস্থিতির মূল্যায়ন করাও সম্ভব।",
    f_exam_detail_notify: "ওয়েবসাইটে প্রকাশিত",
    f_exam_detail_border: "যাদের লিখিত পরীক্ষার মোট স্কোর এবং ব্যবহারিক পরীক্ষার দক্ষতা পরীক্ষা নির্বাহী সংস্থা কর্তৃক নির্ধারিত বিচারের মান স্কোর ছাড়িয়েছে তারা গ্রহণযোগ্য।",
    no_exam_info: "কোনও পরীক্ষার সারসংক্ষেপের তথ্য এখনও প্রকাশ করা হয়নি",
    language: "বাস্তবায়ন ভাষা",
    method: "বাস্তবায়ন পদ্ধতি",
    way: "বাস্তবায়ন পদ্ধতি",
    section: "পরীক্ষার বিভাগ",
    notify: "পরীক্ষার ফলাফলের বিজ্ঞপ্তি",
    border: "পরীক্ষার ফলাফলের মানদণ্ড",
    go_line_at: "লাইন @",
    thank_you_and_deactivate: "ব্যবহারের জন্য আপনাকে ধন্যবাদ। পরিষেবা থেকে সরিয়ে নেওয়ার পদ্ধতির জন্য, দয়া করে নীচের লাইন @ উইন্ডো থেকে প্রত্যাহারের পদ্ধতি প্রবেশ করুন। নিয়মিত পেমেন্ট বাতিল করতে, দয়া করে নীচের লাইন @ উইন্ডো থেকে নিয়মিত পেমেন্ট বাতিল করুন। আমরা নিশ্চিত হওয়ার সাথে সাথে প্রক্রিয়াটি সম্পাদন করব।",
    thank_you_and_subscribe: "ব্যবহার করার জন্য আপনাকে ধন্যবাদ। নিয়মিত পেমেন্ট বাতিল করতে, দয়া করে নীচের লাইন @ উইন্ডো থেকে নিয়মিত পেমেন্ট বাতিল করুন। । n আমরা নিশ্চিতকরণ পাওয়ার সাথে সাথে চুক্তিটি বাতিল করব।",
    ten_thousand_yen: "দশ হাজার ইয়েন",
    yen_per_month: "জেপিওয়াই / মাস",
    how_to_use_this_service: "ব্যবহারের প্রবাহ",
    selecting_a_browser: "ব্রাউজার নির্বাচন",
    selecting_a_browser_dec: "ব্রাউজারের মাধ্যমে https://aelu.co.jp অ্যাক্সেস করুন (গুগল ক্রোম, সাফারি, প্রান্ত ইত্যাদি) * কোনও অ্যাপ নেই।",
    provisional_registration: "অস্থায়ী নিবন্ধকরণ",
    provisional_registration_dec: "আপনার ফেসবুক বা গুগল আইডি দিয়ে লগ ইন করুন বা আপনার ইমেল ঠিকানা দিয়ে নিবন্ধন করুন। পছন্দসই ভাষা এবং পছন্দসই পেশা বাছাই করার পরে, আপনি অনলাইন শংসাপত্র পরীক্ষার উপহাস সামগ্রীটি ব্রাউজ করতে পারেন।",
    full_registration: "প্রধান নিবন্ধকরণ",
    full_registration_dec: "অনলাইন শংসাপত্র পরীক্ষার সামগ্রী পৃষ্ঠাতে প্রধান নিবন্ধকরণ এ ক্লিক করুন, প্রয়োজনীয় তথ্য পূরণ করুন এবং 14 টি শিল্প শংসাপত্র পরীক্ষার অনুশীলন প্রশ্নাবলী সহ সমস্ত পরিষেবা ব্যবহার করুন।",
    name_validate_message: "আপনার পাসপোর্টে প্রদর্শিত হল একই বানান সহ তথ্য লিখুন।",
    live_at_area: "আপনি বর্তমানে বসবাস করেন এমন অঞ্চল",
    agency_application: "পরীক্ষার আবেদনের জন্য অভিনয়",
    mypage: "আমার পাতা",
    myanmar: "বার্মিজ",
    exam_list: "পরীক্ষার সময়সূচী তালিকা",
    no: "না",
    times: "টাইমস",
    application_start: "অ্যাপ্লিকেশন শুরু করুন",
    application_end: "আবেদনের শেষ দিন",
    enforcement: "বাস্তবায়ন",
    applicated: "প্রয়োগ করা হয়েছে",
    reception_time: "অভ্যর্থনা সময়",
    announthment_d: "স্বীকৃতি ঘোষণার তারিখ",
    reception_period: "আবেদন কাল",
    detail_link: "বিশদটি পরীক্ষা করুন",
    exam_country: "স্বাগতিক দেশ",
    line: "লাইন",
    vietnum: "ভিয়েতনাম",
    laos: "লাওস",
    malaysia: "মালয়েশিয়া",
    bangladesh: "বাংলাদেশ",
    indo: "ভারত",
    nepal: "নেপাল",
    mongol: "মঙ্গোলিয়া",
    indonesia: "ইন্দোনেশিয়া",
    th: "থাইল্যান্ড",
    philipine: "ফিলিপিন্স",
    my: "মায়ানমার",
    uzbekistan: "উজবেকিস্তান",
    pakistan: "পাকিস্তান",
    japan: "জাপান",
    news_title: "নির্দিষ্ট দক্ষতা ভিসা সম্পর্কিত খবর",
    missNowPassword: "বর্তমান পাসওয়ার্ডটি ভুল",
    article6_sub2_dec2: "আপনি যদি এখানে আবেদন করেন তবে আমরা পরীক্ষার আবেদন, এক্সাম মূল্য এবং পরীক্ষার দিন পর্যন্ত ভেন্যুটিও ঘোষণা করব।",
    create_naw_password: "পাসওয়ার্ড পরিবর্তন করুন",
    send_confirmcode: "একটি যাচাইকরণ কোড প্রেরণ করা হয়েছে",
    edit: "পরিবর্তন",
    success_new_password_setting: "আপনি একটি নতুন পাসওয়ার্ড সেট করেছেন।",
    error_email: "এটি একটি নিবন্ধভুক্ত ইমেল ঠিকানা।",

    click_here_businesses: "&quot;ব্যবসায়ের জন্য এখানে ক্লিক করুন&quot;",
    regist_organization_staff_info: "ব্যবসায় / ব্যবহারকারী তথ্যের নিবন্ধকরণ",
    organization_info: "বাণিজ্য তথ্য",
    staff_info: "ব্যবহারকারীর তথ্য",
    org_name: "প্রাতিষ্ঠানিক নাম",
    url: "ইউআরএল",
    org_scale: "স্কেল",
    org_zip: "পোস্ট অফিসের নাম্বার",
    org_adress1: "প্রিফেকচারস",
    org_adress2: "শহর",
    org_adress3: "ঠিকানা / অ্যাপার্টমেন্টের নাম",
    org_industry: "শিল্প",
    org_category: "বিভাগ",
    org_description: "বর্ণনা",
    org_established_at: "প্রতিষ্ঠা বছর",
    org_phone: "ব্যবসায়িক ফোন নম্বর",
    failed_established_at: "অবৈধ তারিখ. ",
    staff_name: "ব্যবহারকারীর নাম",
    form_miss: "ইনপুট ফর্মটিতে একটি ভুল রয়েছে। ",

    back_joboffer_detail: "কাজের বিশদে ফিরে যান <",
    create_joboffer: "একটি কাজ তৈরি করুন",
    edit_joboffer: "চাকরি সম্পাদনা করুন",
    stop_posting: "পোস্ট করা বন্ধ করুন",
    delete: "&quot;মুছে ফেলা&quot;",
    job_title: "কাজের শিরোনাম",
    job_catch_phrase: "জব ক্যাচ কপি",
    job_category: "পেশা বিভাগ",
    employed_company_name: "নিয়োগকৃত প্রতিষ্ঠানের নাম",
    work_location: "কর্মক্ষেত্র",
    employment_status: "কর্মসংস্থানের অবস্থা",
    full_time_employee: "নিয়মিত কর্মচারী",
    part_time_job: "খন্ডকালীন চাকরী",
    temporary_staff: "প্রেরিত শ্রম",
    contract_employee: "চুক্তি কর্মচারী",
    intern: "ইন্টার্ন",
    subcontracting: "সাবকন্ট্র্যাক্টিং",
    contract: "চুক্তি",
    new_graduate: "নতুন স্নাতক",
    salary: "বেতন",
    annual_income: "বার্ষিক আয়",
    monthly_salary: "মাসিক বেতন",
    weekly_salary: "সাপ্তাহিক বেতন",
    dayly_salary: "দৈনিক বেতন",
    job_offer_attension1: "কাজের সামগ্রীর জন্য আইন অনুযায়ী নির্ধারিত কাজের শর্তাদি ইত্যাদি নির্দিষ্ট করা প্রয়োজন",
    job_offer_attension2: "দয়া করে কাজের শর্তাদি ইত্যাদি পরীক্ষা করুন যা আইন দ্বারা স্পষ্টভাবে বলা দরকার এবং তারপরে কাজের সামগ্রী বর্ণনা করুন। (তথ্যসূত্র: স্বাস্থ্য, শ্রম ও কল্যাণ মন্ত্রনালয়, প্রিফেকচারাল লেবার ব্যুরো &quot;শ্রমিক নিয়োগের সমস্ত সংস্থার কাছে&quot;) ",
    job_offer_attension3: "আপনি যদি ভাষা ব্যবহার করেন যা লক্ষ্য ব্যক্তির বয়স, লিঙ্গ বা সামাজিক অবস্থানকে সীমাবদ্ধ করে তবে আপনি কোনও চাকরি পোস্ট করতে পারবেন না। ",
    job_offer_attension4: "প্রায়শই অপ্রকাশিত উদাহরণ: &quot;তাদের 20 এর দশকে স্বাগতম&quot; &quot;তরুণদের স্বাগতম&quot; &quot;মহিলারা স্বাগত / সীমাবদ্ধ&quot; &quot;কেবল ছাত্র&quot;",
    work_content_appeal: "কাজের বিষয়বস্তু এবং আবেদন পয়েন্ট",
    work_content_appeal_desc: "চাকরি সন্ধানকারীদের আগ্রহী হওয়া আরও সহজ হবে যদি আপনি প্রথমে আপিল পয়েন্টগুলি তাদের বলেন। ",
    human_resources_seek: "অনুসন্ধানের মানবসম্পদ",
    human_resources_seek_desc: "আপনি যে দক্ষতাগুলি সন্ধান করছেন কেবল তা নয়, এমন তথ্যও যা চাকরি প্রার্থীদের কর্মক্ষেত্র কল্পনা করতে দেয়। ",
    working_hours: "কর্মঘন্টা",
    traffic_access: "ট্র্যাফিক অ্যাক্সেস",
    traffic_access_desc: "কেবল গণপরিবহনের তথ্যই নয়, গাড়িতে করে চলাচল করুন, কর্মচারীদের জন্য কোনও পার্কিং রয়েছে কিনা ইত্যাদি ",
    required: "প্রয়োজনীয়",
    optional: "যে কোনও",
    other: "অন্যান্য",
    photo: "ফটো",
    upload_video: "ভিডিও আপলোড কর",
    job_tag: "জব ট্যাগ",
    until_select_three: "3 টি পর্যন্ত নির্বাচনযোগ্য",
    senior_support: "সিনিয়র সমর্থন",
    salary_increase_promotion: "বেতন বৃদ্ধি / প্রচার উপলব্ধ",
    no_overtime: "অতিরিক্ত সময় নেই",
    target_hiring_time: "নিয়োগের লক্ষ্য সময়",
    additional_questions: "অতিরিক্ত প্রশ্নাবলী",
    job_offer_title: "কাজের নাম",
    public: "মুক্তি",
    private: "ব্যক্তিগত",
    public_status: "পাবলিক স্ট্যাটাস",
    occupation: "পেশা",
    walfare: "চিকিত্সা / উপকারিতা",
    create: "&quot;সৃষ্টি&quot;",
    hour: "সময়",
    back_mypage: "আমার পৃষ্ঠায় ফিরে যান <",
    job_offers: "কাজের তালিকা",
    look_matches: "ম্যাচের তালিকাটি দেখুন",
    now_public: "এখন উন্মুক্ত",
    now_private: "অপ্রকাশিত",
    check: "কনফার্ম",
    edit2: "সম্পাদনা করতে",
    news_detail: "সংবাদ বিবরণ",
    prefectures: "প্রিফেকচারস",

    hokkaido: "হোক্কাইডো",
    aomori: "আমোরি",
    iwate: "ইওয়াতে",
    miyagi: "মিয়াগি",
    akita: "আকিতা",
    yamagata: "যমগতা",
    fukushima: "ফুকুশিমা",
    ibaraki: "ইবারাকী",
    tochigi: "তোচিগি",
    gunma: "গুনমা",
    saitama: "সাইতামা",
    chiba: "চিবা",
    tokyo: "টোকিও",
    kanagawa: "কানাগাওয়া",
    niigata: "নিগাতা",
    toyama: "&quot;তোয়ামা&quot;",
    ishikawa: "Ikশিকাওয়া",
    fukui: "ফুকুই",
    yamanashi: "ইয়ামানশি",
    nagano: "নাগানো",
    gifu: "জিফু",
    shizuoka: "শিজুওকা",
    aichi: "আইচি",
    mie: "ট্রিপল",
    shiga: "শিগা",
    kyoto: "কিয়োটো",
    osaka: "ওসাকা",
    hyogo: "হায়োগো",
    nara: "নারা",
    wakayama: "ওয়াকায়ামা",
    tottori: "টোটোরি",
    shimane: "শিমনে",
    okayama: "ওকায়ামা",
    hiroshima: "হিরোশিমা",
    yamaguti: "ইয়ামাগুচি",
    tokushima: "টোকুশিমা",
    kagawa: "কাগয়া",
    echime: "এহাইম",
    kochi: "কোচি",
    fukuoka: "ফুকুওকা",
    saga: "সাগা",
    nagasaki: "&quot;নাগাসাকি&quot;",
    kumamoto: "কুমামোটো",
    oita: "ওটা",
    miyazaki: "মিয়াজাকি",
    kagoshima: "কাগোশিমা",
    okinawa: "ওকিনাওয়া",
    sinhalese: "সিংহালা",
    exam_region: "প্রিফেকচারস",
    exam_place_list: "স্থানগুলির তালিকা",
    exam_place_name: "পরীক্ষার স্থানের নাম",
    care_evaluation_test: "দীর্ঘমেয়াদী যত্ন দক্ষতা প্রশিক্ষণের মূল্যায়ন পরীক্ষা",
    clean_building_test: "বিল্ডিং ক্লিনিং ইন্ডাস্ট্রির অতীত সমস্যা",
    answer: "উত্তর",
    skill_test_measurement: "দক্ষতা পরিমাপ পরীক্ষা",
    exam_problem: "পরীক্ষার প্রশ্ন",
    fields: "ক্ষেত্র এবং শাকসবজি",
    gardening: "সুবিধাময় বাগান",
    mushroom: "মাশরুম",
    fruit: "ফলের গাছ",
    dairy: "দুগ্ধ",
    poultry: "পোল্ট্রি",
    pig: "শুকর চাষ",
    beginner: "শিক্ষানবিস",
    professional: "পেশাদার গ্রেড",
    advanced: "অ্যাডভান্সড",
    technical_training_test: "প্রযুক্তিগত ইন্টার্ন প্রশিক্ষণ মূল্যায়ন পরীক্ষা",
    exam_part: "পরীক্ষার প্রশ্নগুলির অংশ",
    tokoha_fruit: "টোকোহা ফলের গাছ",
    deciduous_fruit: "পাতলা ফলের গাছ",
    ver: "সংস্করণ",
    errata: "ত্রুটি",
    form_work: "ফর্মওয়ার্ক নির্মাণ",
    construction: "প্লাস্টারিং",
    tunnel_line: "টানেল প্রোপালশন লাইন",
    earth_work: "আর্থওয়ার্ক",
    loofing: "ছাদ",
    elecommunication: "টেলিযোগাযোগ",
    reinforcing_contstruction: "পুনর্গঠিত বার নির্মাণ",
    reinforcing_joint: "রিইনফোর্সিং বার জয়েন্ট",
    wall_painting: "পেইন্টিং (প্রাচীরের আচ্ছাদন)",
    board_finish: "বোর্ড ফিনিস, ইন্টিরিয়ার ফিনিস",
    steeplejack: "টবি",
    spray_insulation: "স্প্রেড ইউরেথেন অন্তরণ",
    marine_civil: "মেরিন সিভিল ইঞ্জিনিয়ারিং",
    concrete_pumping: "কংক্রিট পাম্পিং",
    construction_machinery: "নির্মাণ যন্ত্রপাতি নির্মাণ",
    learning_text: "পাঠ্য শেখা",

    basic_aircraft: "প্রাথমিক বিমান প্রযুক্তি, বৈদ্যুতিক পরিমাপের উপসংহার",
    worksafety_quality: "কাজের সুরক্ষা, গুণমান",
    aircraft_overview: "বিমানের ওভারভিউ",
    fish_general: "সাধারণভাবে ফিশারি",
    fish_safety: "ফিশারি সেফটি",
    network_relations: "ফিশারি স্পেশালাইজড ক্লাস",
    fish_relations: "ফিশারি স্পিশিটি ফিশিং রিলেটেড",
    aquaculture_general: "সাধারণভাবে জলজ পালন",
    feeding_aquaculture: "জলছবি বিশেষ খাওয়ানো এবং জলজ চাষ সম্পর্কিত",
    unfed_aquaculture: "জলজ চাষ বিশেষত জলছবি সম্পর্কিত",
    attachment: "সংযুক্তি",
    glossary: "শব্দকোষ",
    feneral_customer: "সাধারণ গ্রাহক পরিষেবা",
    food_dring_cooking: "রান্না করা খাবার এবং পানীয়",
    hygiene_management: "হাইজিন ম্যানেজমেন্ট",
    visa_application: "নির্দিষ্ট দক্ষতার ভিসার জন্য আবেদন",
    certificate_residence_tax: "১. আবাসনের করের শংসাপত্র (গত বছরের জন্য)",
    salary_income_withholding : "২. বেতন আয়ের হোল্ডিং স্লিপের অনুলিপি",
    national_health_insured: "৩. জাতীয় স্বাস্থ্য বীমা বীমাকৃত ব্যক্তির কার্ডের একটি অনুলিপি (যদি ব্যক্তি নিবন্ধিত থাকে)",
    national_health_payment: "৪. জাতীয় স্বাস্থ্য বীমা প্রিমিয়াম প্রদানের শংসাপত্র",
    national_health_receipt: "৫. জাতীয় স্বাস্থ্য বীমা প্রিমিয়ামের প্রাপ্তির অনুলিপি",

    technical_intern_training2: "Technical. নং টেকনিক্যাল ইন্টার্ন প্রশিক্ষণ সফলভাবে সম্পন্ন হয়েছে এমন নথিপত্রাদি",
    need_the_following : "আপনার নিম্নলিখিতগুলির একটি প্রয়োজন: ",
    pass_certificate_test_specialized : "・ দক্ষতা মূল্যায়ন পরীক্ষার ব্যবহারিক দক্ষতা পরীক্ষার পাসের শংসাপত্রের একটি অনুলিপি (বিশেষ গ্রেড)",
    technical_intern_training3: "Skill দক্ষতা পরীক্ষার ব্যবহারিক পরীক্ষার পাসের শংসাপত্রের একটি অনুলিপি (তৃতীয় গ্রেড)",
    evaluation_record_technical_intern: "You আপনি যদি উপরের পরীক্ষায় পাস না করেন তবে আপনাকে প্রযুক্তিগত ইন্টার্ন প্রশিক্ষণার্থীর মূল্যায়ন রেকর্ডটি পূরণ করতে হবে। ",
    cartificate_pass_basic_test: "7..6 এর বিকল্প হিসাবে, আপনি জাপান ফাউন্ডেশন জাপানিজ বেসিক টেস্টের পাস শংসাপত্রের একটি অনুলিপি বা জাপানিজ ভাষা দক্ষতা পরীক্ষার (এন 4) বা তারও বেশি পাসের শংসাপত্রের একটি অনুলিপি জমা দিতে পারেন। ",
    change_permission_application: "৮. পরিবর্তন অনুমতি অ্যাপ্লিকেশন এর ছবি (উল্লম্ব 4 সেমি এক্স অনুভূমিক 3 সেমি)",
    resume_data_time_entry: "Entry। প্রবেশের সময় ডেটা আবার শুরু করুন",
    select_file: "ফাইলগুলি নির্বাচন করুন",

    description_movie: "ব্যাখ্যার ভিডিও",
    how_to_use_movie: "কীভাবে ভিডিও ব্যবহার করবেন",
    movie_news: "1. নির্দিষ্ট দক্ষতা ভিসা সম্পর্কে সংবাদ",
    movie_exam: "২. পরীক্ষার তারিখ পর্যন্ত অবশিষ্ট দিনগুলি",
    movie_predict_pass: "৩. পাসের হার আনুমানিক",
    movie_ave_study_test: "৪. আপনার নিজের পড়াশোনার গড় স্কোর",
    movie_similar_exam: "৫. অনুরূপ পরীক্ষার প্রশ্নসমূহ",
    movie_learning_text: "The. শেখার পাঠ্যপুস্তক (পাঠ্যপুস্তক) ডাউনলোড করুন",
    movie_solved_exam: "Pro. আমি অতীতে সমস্যার সমাধান করেছি",
    movie_pased_exam: "৮. বাস্তবে উপস্থিত হওয়া অতীতের সমস্যাগুলি সম্পর্কে",
    movie_resume_regist: "9. প্রবেশের সময় নিবন্ধন পুনরায় শুরু করুন",
    movie_pass_document_regist: "10. দক্ষতা পরীক্ষা পাসের নিবন্ধন",
    movie_agency_service: "১১. পরীক্ষার আবেদন এজেন্সি পরিষেবা",
    movie_consule_service: "12. পরামর্শ পরিষেবা শেখা",
    description_movie_trans: "আপনি যদি জাপানি ছাড়া অন্য কোনও ভাষাতে দেখতে চান তবে গিয়ার চিহ্নটি ক্লিক করুন, সাবটাইটেল এবং স্বয়ংক্রিয় অনুবাদ ক্লিক করুন, আপনার স্থানীয় ভাষা নির্বাচন করুন এবং তারপরে দেখুন।",

"cultivated_agriculture_general": "সাধারণভাবে চাষ করা কৃষি",
"livestock_agriculture": "পশুসম্পদ কৃষি",
"介護": "নার্সিং",
"ビルクリーニング": "বিল্ডিং পরিষ্কার",
"建設": "নির্মাণ",
"自動車整備": "গাড়ী রক্ষণাবেক্ষণ",
"航空業": "বিমান শিল্প",
"農業": "কৃষি",
"漁業": "মাছ ধরা",
"飲食料品製造業": "খাদ্য ও পানীয় উৎপাদন শিল্প",
"外食業": "রেস্টুরেন্ট ব্যবসা",
"型枠施工": "ফর্মওয়ার্ক নির্মাণ",
"左官": "প্লাস্টার",
"コンクリート圧送": "কংক্রিট পাম্পিং",
"トンネル推進工": "টানেল প্রপালশন কাজ",
"建設機械施工": "নির্মাণ যন্ত্রপাতি নির্মাণ",
"大工": "কাঠমিস্ত্রি",
"屋根ふき": "ছাদ",
"電気通信": "টেলিযোগাযোগ",
"鉄筋施工": "বার নির্মাণ শক্তিশালীকরণ",
"鉄筋継手": "বার জয়েন্ট শক্তিশালীকরণ",
"壁装（壁張り）": "দেয়াল আচ্ছাদন (দেয়াল আচ্ছাদন)",
"ボード仕上げ、内装仕上げ": "বোর্ড ফিনিস, ইন্টেরিয়র ফিনিস",
"とび": "ঝাঁপ দাও",
"吹き付けウレタン断熱": "স্প্রে করা ফায়ারিং ইনসুলেশন",
"海洋土木工": "মেরিন সিভিল ইঞ্জিনিয়ারিং",
"航空機の基本技術 締結、電気計測": "বিমানের মৌলিক প্রযুক্তির উপসংহার, বৈদ্যুতিক পরিমাপ",
"作業安全、品質": "কাজের নিরাপত্তা, গুণমান",
"航空機概要": "বিমান ওভারভিউ",
"耕種農業全般": "সাধারণভাবে চাষ করা কৃষি",
"畜産農業": "পশুসম্পদ কৃষি",
"漁業一般": "সাধারণভাবে মাছ ধরা",
"漁業安全": "মৎস্য নিরাপত্তা",
"漁業専門 綱関係": "মৎস্য বিশেষ দড়ি সম্পর্ক",
"漁業専門 釣り関係": "মাছ ধরার সাথে সম্পর্কিত মাছ ধরার বিশেষজ্ঞ",
"養殖業一般": "সাধারণভাবে জলজ পালন",
"養殖業専門 給餌養殖関係": "জলজ পালনের বিশেষত্ব জলজ পালন",
"養殖業専門 無給餌養殖関係": "অ্যাকুয়াকালচার স্পেশালিটি আনফেড অ্যাকুয়াকালচার",
"接客全般": "সাধারণ গ্রাহক পরিষেবা",
"飲食物調理": "খাবার ও পানীয় রান্না",
"衛生管理": "স্বাস্থ্যবিধি ব্যবস্থাপনা",
"日本語版": "জাপানি সংস্করণ",
"英語版": "ইংরেজি সংস্করণ",
"クメール語版": "খমের সংস্করণ",
"インドネシア語版": "ইন্দোনেশিয়ান সংস্করণ",
"インドネシア語・正誤表": "ইন্দোনেশিয়ান ত্রুটি",
"ネパール語版": "নেপালি সংস্করণ",
"モンゴル語版": "মঙ্গোলিয়ান সংস্করণ",
"ビルマ語版": "বার্মিজ সংস্করণ",
"ベトナム語版": "ভিয়েতনামী সংস্করণ",
"タイ語版": "থাই সংস্করণ",
"テキスト１": "পাঠ্য 1",
"テキスト２": "পাঠ্য 2",
"テキスト３": "পাঠ্য 3",
"テキスト４": "পাঠ্য 4",
"テキスト５": "পাঠ্য 5",
"ミャンマー(ビルマ)語版": "মায়ানমার (বর্মী) ভাষার সংস্করণ",
"カンボジア(クメール)語版": "কম্বোডিয়া (খমের) ভাষার সংস্করণ",
"ミャンマー語版": "বার্মিজ সংস্করণ",
"中国語版": "চীনা সংস্করণ",
"付属資料": "সংযুক্তি",
"用語集": "শব্দকোষ",

"invitation_code": "আমন্ত্রণ কোড",
"exam_calender": "পরীক্ষার সময়সূচী ক্যালেন্ডার",
"move_exam_detail": "আপনি কি পরীক্ষার সময়সূচীর বিবরণ পৃষ্ঠায় যেতে চান?",
"move": "চলন্ত",
"plece_select_language": "একটি ভাষা নির্বাচন করুন",
"select": "নির্বাচন করুন",
"midle_category": "পেশা",
"select_industry_description": "শুরুতে, AELU শুধুমাত্র 3টি শিল্প পর্যন্ত নির্বাচন করতে পারে, তাই আপনি যে শিল্পের জন্য কাজ করতে চান তা বেছে নিন। আপনি এটির সাথে খুশি হলে, পরবর্তী টিপুন",
"done_member_regist_description_2": "এখন থেকে, আমরা প্রচুর সার্টিফিকেশন পরীক্ষার প্রস্তুতির মাধ্যমে একটি নির্দিষ্ট দক্ষতার ভিসা পেতে AELU-কে সমর্থন করব।",
"done_member_regist_2": "সদস্য নিবন্ধন সম্পূর্ণ হয়েছে.",
"is_exist_user": "একই ইমেল ঠিকানা সহ একজন ব্যবহারকারী ইতিমধ্যেই বিদ্যমান৷",
"invitation_code_description": "(অনুগ্রহ করে প্রেরক সংস্থা বা জাপানি ভাষা স্কুল থেকে আমন্ত্রণ কোড লিখুন, অন্যথায় ব্যয় নিষ্পত্তি স্ক্রীন প্রদর্শিত হবে, তাই এটি লিখতে ভুলবেন না।)",
"pleace_select_region": "হোস্ট প্রিফেকচার নির্বাচন করুন",
"pleace_add_messenger": "সমস্ত পরিচিতি Facebook মেসেজারের মাধ্যমে পাঠানো হবে তাই তাদের যোগ করতে ভুলবেন না",
"add_messenger_bot": "বিজ্ঞপ্তি পান",
"visa_application_description": "একটি নির্দিষ্ট দক্ষতা ভিসার জন্য আবেদন করার সময় প্রয়োজনীয় নথি সংরক্ষণের অবস্থান",
"check_agree": "অনুগ্রহ করে একমত",
"sample_title": "এটি একটি ডামি শিরোনাম। সেট করুন",
"sample_description": "এটি একটি ডামি বর্ণনা। সেট করুন. এটি একটি ডামি বর্ণনা। সেট করুন. এটি একটি ডামি বর্ণনা। সেট করুন. এটি একটি ডামি বর্ণনা। সেট করুন. এটি একটি ডামি বর্ণনা। সেট করুন. এটি একটি ডামি বর্ণনা। সেট করুন. এটি একটি ডামি বর্ণনা। সেট করুন.",
"create_profile_error": "ইনপুট একটি ত্রুটি আছে. আইটেম চেক করুন",
"setting_confirm": "অনুগ্রহ করে ইনপুট বিষয়বস্তু নিশ্চিত করুন এবং নিবন্ধন করুন",
"exam_learning": "পরীক্ষা শেখা",
"recommend_problem_solve": "অনুরূপ পরীক্ষার প্রশ্নগুলি সমাধান করুন",
"of": "এর",
"see_solved_problem": "আপনি অতীতে সমাধান করেছেন এমন সমস্যার সমাধান করুন",
"past_exam_collection": "\nপরীক্ষার প্রশ্ন যা অতীতে হাজির হয়েছিল",
"any_application_registration": "বিভিন্ন আবেদন নিবন্ধন",
"mypage_visa_application": "নির্দিষ্ট দক্ষতা ভিসা \n আবেদন",
"applyt_exam_and_agent": "পরীক্ষার আবেদন \n প্রক্সি পরিষেবা অ্যাপ্লিকেশন",
"myapge_regist_accept_certificate": "দক্ষতা পরীক্ষা\nপাশের নিবন্ধন",
"mypage_consultaion_service": "শেখার পরামর্শ \n সেবা",
"consult": "পরামর্শ করুন",
"of_exam_day": "পরীক্ষার তারিখ",
"your_ave_score": "আপনার \n পরীক্ষার গড় স্কোর",
"your_estimated_pass_rate": "আপনার \n আনুমানিক পাসের হার",
"your_ave_score_fotter": "আপনার পরীক্ষার জন্য গড় স্কোর",
"your_estimated_pass_rate_fotter": "আনুমানিক পাসের হার",
"mypage_study_text": "শেখার পাঠ্যপুস্তক ডাউনলোড করুন \n",
"exam_schedule": "পরীক্ষার সময়সূচী",
"resident_caption_title": "● একটি আবাসিক কার্ড বা আইডি কার্ড আপলোড সম্পর্কে",
"resident_caption": "অনুগ্রহ করে একটি আবাসিক কার্ড বা আইডি কার্ড আপলোড করুন যা লাল ফ্রেমে তথ্য নিশ্চিত করতে পারে। \nঅনুগ্রহ করে একটি বৈধ আবাসিক কার্ড বা আইডি কার্ড আপলোড করুন যার মেয়াদ শেষ হয়নি। \n PDF বা JPG ফরম্যাটে একটি রঙিন ছবি আপলোড করুন।",
"password_caption_title": "● পাসওয়ার্ড আপলোড করার বিষয়ে",
"password_caption": "অনুগ্রহ করে একটি পাসপোর্ট ছবি আপলোড করুন যা লাল ফ্রেমে দেখানো আপনার নাম / ছবি / অনন্য নম্বর / জন্ম তারিখ / জাতীয়তা / মেয়াদ শেষ হওয়ার তারিখ নিশ্চিত করে। \nঅনুগ্রহ করে একটি বৈধ পাসপোর্ট আপলোড করুন যার মেয়াদ শেষ হয়নি। \n PDF বা JPG ফরম্যাটে একটি রঙিন ছবি আপলোড করুন।",
"title_help": "সাহায্য",
"step3_title_help": "আপনার তথ্য সঠিকভাবে লিখুন.",
"lineid_input_help": "আইডি দেখতে লাইন → হোম → সেটিংস → প্রোফাইল → স্ক্রোল করুন। দয়া করে সেই আইডি লিখুন। আপনি যদি এটি তৈরি না করে থাকেন তবে দয়া করে এটি তৈরি করুন এবং প্রবেশ করুন।",
"country_input_help": "আপনার জাতীয়তার দেশ নির্বাচন করুন.",
"area_input_help": "আপনার এলাকার দেশ নির্বাচন করুন যেখানে আপনি বর্তমানে থাকেন।",
"phone_input_help": "অনুগ্রহ করে আপনার ফোন নাম্বারটি প্রদান করুন।",
"issuing_input_help": "আপনার আইডি ইস্যু করা হয়েছে যে এলাকা নির্বাচন করুন.",
"idtype_input_help": "একটি আইডি প্রকার নির্বাচন করুন. অনুগ্রহ করে নির্বাচিত ব্যক্তির একটি সুন্দর ছবি তুলে আপলোড করুন। দয়া করে সোজা অঙ্কুর করুন যাতে কোনও তির্যক বা কাটা বিন্দু না থাকে।",
"invitation_input_help": "আপনার যদি একটি আমন্ত্রণ কোড থাকে, তাহলে সেটি লিখুন।",
"exam_menu_help": "এমন প্রশ্ন থাকবে যা আসলে অতীতে যে প্রশ্নগুলো জিজ্ঞাসা করা হয়েছিল তার অনুরূপ। পরীক্ষার প্রস্তুতির জন্য বারবার প্রশ্নের সমাধান করুন।",
"past_menu_help": "আপনি অতীতে সমাধান করেছেন যে সমস্যা আছে. আসুন ভুলগুলো পর্যালোচনা করি।",
"pastexam_menu_help": "এটি পরীক্ষার প্রশ্নগুলির পাঠ্য যা আসলে অতীতে বিদ্যমান ছিল।",
"text_menu_help": "গুরুত্বপূর্ণ বিষয়গুলি অধ্যয়ন করতে এবং আপনি কী বোঝেন না তা জানতে অধ্যয়নের পাঠ্যপুস্তকগুলি দেখতে পারেন।",
"visa_menu_help": "আমরা আপনাকে একটি নির্দিষ্ট দক্ষতার ভিসা পেতে সাহায্য করব। আপনি যদি একটি নির্দিষ্ট দক্ষতার জন্য ভিসা পেতে চান তবে দয়া করে এখানে আবেদন করুন।",
"agency_menu_help": "আমরা আপনার পক্ষ থেকে নির্দিষ্ট দক্ষতা পরীক্ষার জন্য আবেদন করব। আপনি যদি একটি নির্দিষ্ট দক্ষতা পরীক্ষা দিতে চান, এখানে আবেদন করুন.",
"cer_menu_help": "আপনি যদি নির্দিষ্ট দক্ষতা পরীক্ষা দিয়ে থাকেন এবং পাসের শংসাপত্র থাকে তবে অনুগ্রহ করে এখানে নিবন্ধন করুন।",
"service_menu_help": "আপনার কোন প্রশ্ন বা উদ্বেগ থাকলে, এখানে চ্যাট মাধ্যমে আমাদের সাথে যোগাযোগ করুন.",
"occu_title_help": "অনুগ্রহ করে 3টি পর্যন্ত পছন্দসই পেশা নির্বাচন করুন।",
"back": "প্রত্যাবর্তন",
"before": "আগের সমস্যায়",
srilank: "শ্রীলংকা",
reselect: "আপনি যদি ফাইলটি পরিবর্তন করতে চান, আবার &quot;আপনার পাসপোর্ট আপলোড করুন&quot; টিপুন এবং আবার নির্বাচন করুন৷",
iphone_file: "আইফোনের জন্য, দয়া করে HEIC ফাইল থেকে JPG ফাইলে রূপান্তর করার পরে ব্যবহার করুন৷",
file_transmit: "ফাইল কনভার্ট করুন",
combodia: 'combodia',
}
